import { ValueOf } from '../common/utils';

export const EVENT_STATUS_V2 = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  UNLIMITED: 'unlimited',
} as const;

export type EVENT_STATUS_V2 = ValueOf<typeof EVENT_STATUS_V2>;
